import * as Icons from "@nova/component-icons"

import type { JSX } from "react"

export const WorkspaceHomeLearnItem = ({
    Icon,
    title,
    body,
    Button,
}: {
    Icon: Icons.IconComponent
    title: string
    body: string
    Button: () => JSX.Element
}) => {
    return (
        <div className="relative flex gap-4 select-none">
            <Icon />
            <div className="flex flex-col gap-2 flex-grow">
                <h4 className="text-gray-0">{title}</h4>
                <h4 className="text-gray-100">{body}</h4>
            </div>
            <Button />
        </div>
    )
}
